import { CSSObject } from "@emotion/react";
import {
  type AnchorStyleOverrides,
  type AngelouCSS,
  constants,
} from "@newsela/angelou";

export const resourceItemsVisibilityBreakpointsCss = (isVisible: boolean) =>
  isVisible
    ? {
        display: "flex",
      }
    : {
        display: "none",
      };

export const resourceItemsContainerCss = {
  display: "flex",
  alignItems: "center,",
  gap: "0.5rem",
};

export const assignmentsAnchorCss: AnchorStyleOverrides<AngelouCSS> = {
  root: {
    textDecoration: "none",
    color: constants.colors.ui.neutral[600],

    ":hover": {
      color: constants.colors.ui.core[700],
    },
  },
};

export const relativeLiCss: CSSObject = {
  position: "relative",
};
